import { render, staticRenderFns } from "./settingsPushNotificationsHistory.vue?vue&type=template&id=a8420010&scoped=true&"
import script from "./settingsPushNotificationsHistory.vue?vue&type=script&lang=js&"
export * from "./settingsPushNotificationsHistory.vue?vue&type=script&lang=js&"
import style0 from "./settingsPushNotificationsHistory.vue?vue&type=style&index=0&id=a8420010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8420010",
  null
  
)

export default component.exports